import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import OurTeamLanding from "../views/OurTeamLanding";

export default function OurTeam() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  useEffect(() => {
    if (
      !appContext.navSubItem &&
      !appContext.navExtraItem &&
      !appContext.navMoreItem
    ) {
      setView(<OurTeamLanding />);
    } else {
      setView(null);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
